// extracted by mini-css-extract-plugin
export default {"switchContainer":"DeleteChat_switchContainer_EUkD8"};